
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';
import MDTypography from 'components/MDTypography';
import {
    getFundingSourceList,
    deleteFundingSource,
    deleteFundingSourceRequest,
    getDeactivatedUsersList
} from 'store/reducers/fundingSourceSlice';
import { Box } from '@mui/material';

const useDeactivateUsersHook = () => {
    const dispatch = useDispatch();
    const { fundingSourceList } = useSelector((state) => state.fundingSource);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [perPage, setPerPage] = useState(10);
    const [isRemovalModal, setIsRemovalModal] = useState(false);
    const [isDeclineModal, setIsDeclineModal] = useState(false);
    const [saveFundingSourceId, setSaveFundingSourceId] = useState(null);
    const [isFundingSourceLoading, setIsFundingSourceLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const closeRemovalModal = () => {
        setIsRemovalModal(false);
    }

    const closeDeclineModal = () => {
        setIsDeclineModal(false)
    }

    const removeFundingSource = async () => {
        try {
            setIsFundingSourceLoading(true);

            const filtersObject = {
                sourceId: saveFundingSourceId,
            };

            await dispatch(deleteFundingSource(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setIsFundingSourceLoading(false);
        }
        setIsRemovalModal(false);
    }
    const declineFundingSourceRequest = async () => {
        try {
            setIsFundingSourceLoading(true);

            const filtersObject = {
                sourceId: saveFundingSourceId,
            };

            await dispatch(deleteFundingSourceRequest(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setIsFundingSourceLoading(false);
        }
        setIsDeclineModal(false)
    }
    const rows = useMemo(() => {
        return fundingSourceList?.deactivatedUsersData?.length > 0
            ? fundingSourceList?.deactivatedUsersData?.map((user) => ({
                id: user?.userId ?? 'NA',
                userId: user?.userId ?? 'NA',
                name: user?.name ?? 'NA',
                email: user?.email ?? 'NA',
                state: user?.state ?? 'NA',
                city: user?.city ?? 'NA',
                isKYCVerified: user?.isKYCVerified ? 'Yes' : 'No' ?? 'NA',
                isAdminApproved: user?.isAdminApproved ? 'Yes' : 'No' ?? 'NA', 
                phoneNumber: user?.phoneNumber ?? 'NA',
                subscribeForSMS: user?.subscribeForSMS ? 'Yes' : 'No' ?? 'NA',
                referredBy: user?.referredBy ?? 'NA',
                onboardingStage: user?.onboardingStage ?? 'NA',
                registeredOn: user?.registeredOn ?? 'NA',
                accountStatus: user?.accountStatus ?? 'NA',
                isRegDInvestor: user?.isRegDInvestor ?? 'NA',
                referredUser: user?.referredByUser?.name ?? 'NA',
            }))
            : [];
    }, [fundingSourceList?.deactivatedUsersData]);

    async function fetchTransactions() {
        try {
            setLoading(true);

            const filtersObject = {
                page: currentPage + 1,
                limit: perPage,
            };

            await dispatch(getFundingSourceList(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    async function fetchDeactivateUsersList() {
        try {
            setLoading(true);

            const filtersObject = {
                page: currentPage + 1,
                limit: perPage,
                searchTerm: searchTerm
            };

            await dispatch(getDeactivatedUsersList(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    const onFetchDataDebounced = debounce(fetchDeactivateUsersList, 0);

    useEffect(() => {
        onFetchDataDebounced();

        return () => {
            onFetchDataDebounced.cancel();
        };
    }, [
        currentPage,
        perPage,
        searchTerm
    ]);
    return {
        rows,
        isLoading,
        currentPage,
        setCurrentPage,
        isRemovalModal,
        isDeclineModal,
        closeRemovalModal,
        closeDeclineModal,
        removeFundingSource,
        declineFundingSourceRequest,
        isFundingSourceLoading,
        setPerPage,
        perPage,
        totalCount: fundingSourceList?.totalCount,
        totalPage: fundingSourceList?.totalPage,
        searchTerm,
        setSearchTerm
    };
}

export default useDeactivateUsersHook;